import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

export function ItemLessReasonDialog({
    open,
    onOpenChange,
    itemLessReasons,
    itemName,
    onConfirm
}) {
    const [selectedReasonId, setSelectedReasonId] = useState("");
    const [customReason, setCustomReason] = useState("");

    const handleConfirm = () => {
        if (!selectedReasonId) {
            return;
        }

        const selectedReason = itemLessReasons.find(
            reason => reason.ItemLessReasonId?.toString() === selectedReasonId
        );

        const payload = {
            ...selectedReason,
            CustomReason: customReason.trim() || "",
        };

        onConfirm(payload);
        setSelectedReasonId("");
        setCustomReason("");
        // onOpenChange(false);
    };

    const handleCancel = () => {
        setSelectedReasonId("");
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Select Item Less Reason</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid gap-2">
                        <Label htmlFor="reason">Reason *</Label>
                        {itemLessReasons && itemLessReasons.length > 0 ? (
                            <div className="grid grid-cols-1 gap-2 max-h-[300px] overflow-y-auto">
                                {itemLessReasons.map((reason) => {
                                    const reasonId = reason.ItemLessReasonId?.toString();
                                    const isSelected = selectedReasonId === reasonId;
                                    return (
                                        <Button
                                            key={reason.ItemLessReasonId}
                                            type="button"
                                            variant={isSelected ? "default" : "outline"}
                                            onClick={() => setSelectedReasonId(reasonId)}
                                            className={`w-full justify-start text-left ${isSelected
                                                ? "bg-primary text-primary-foreground"
                                                : "hover:bg-accent"
                                                }`}
                                        >
                                            {reason.ItemLessReasonName || reason.ReasonName || "Unknown Reason"}
                                        </Button>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-sm text-muted-foreground py-4 text-center">
                                No reasons available
                            </div>
                        )}
                    </div>

                    <div className="grid gap-2">
                        <Label htmlFor="reason">Custom Reason </Label>

                        <div className="grid grid-cols-1 gap-2 max-h-[300px] overflow-y-auto">
                            <Input
                                id="customReason"
                                value={customReason}
                                onChange={(e) => {
                                    setCustomReason(e.target.value);
                                }}
                                placeholder="Enter Reason"
                                className="mt-1"
                            />
                        </div>
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} disabled={!selectedReasonId}>
                        Confirm
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

